import $ from 'jquery';

// Not used
// import axios from 'axios';
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import VanguardConfig from '../../config/vanguard';
import {version} from '../../package.json';
import {Severity} from '@sentry/browser';
import SentryLogger from '@/common/mixins/sentry-logger';


/**
 * Components
 */
import PaymentSwitchButton from '../common/components/payment-switch-button.vue';
import ValidateOrderButton from './components/validate-order-button.vue';
import ContactForm from './components/contact-form.vue';
import PaymentForm from '../common/components/payment-form.vue';
import BillingRecap from '../common/components/billing-recap.vue';
import OrderRecap from './components/order-recap.vue';
import OopsButton from '../common/components/oops-button.vue';

/**
 * Components Variables
 */
import AmountOldTotalCc from './components/variables/amount-old-total-cc.vue';
import AmountOldTotalSepa from './components/variables/amount-old-total-sepa.vue';
import AmountOldTotalX1 from './components/variables/amount-old-total-x1.vue';
import AmountOldTotalX3Total from './components/variables/amount-old-total-x3-total.vue';
import AmountOldTotalX3 from './components/variables/amount-old-total-x3.vue';
import AmountOldTotal from './components/variables/amount-old-total.vue';
import AmountTotalCc from './components/variables/amount-total-cc.vue';
import AmountTotalSepa from './components/variables/amount-total-sepa.vue';
import AmountTotalX1 from './components/variables/amount-total-x1.vue';
import AmountTotalX2 from './components/variables/amount-total-x2.vue';
import AmountOldTotalX2 from './components/variables/amount-old-total-x2.vue';
import AmountOldTotalX2Total from './components/variables/amount-old-total-x2-total.vue';
import AmountTotalX2Total from './components/variables/amount-total-x2-total.vue';
import AmountTotalDiffX1X2Total from './components/variables/amount-total-diff-x1-x2-total.vue';
import AmountTotalX3Total from './components/variables/amount-total-x3-total.vue';
import AmountTotalX3 from './components/variables/amount-total-x3.vue';
import AmountTotal from './components/variables/amount-total.vue';
import AmountTotalDiffX1X3Total from './components/variables/amount-total-diff-x1-x3-total.vue';
import ChoiceOldPrice from './components/variables/choice-old-price.vue';
import ChoicePriceCc from './components/variables/choice-price-cc.vue';
import ChoicePriceSepa from './components/variables/choice-price-sepa.vue';
import ChoicePriceX1 from './components/variables/choice-price-x1.vue';
import ChoicePriceX3Total from './components/variables/choice-price-x3-total.vue';
import ChoicePriceX3 from './components/variables/choice-price-x3.vue';
import ChoicePrice from './components/variables/choice-price.vue';
import ChoicePriceRecurrence from './components/variables/choice-price-recurrence.vue';
import ChoiceDescription from './components/variables/choice-description.vue';
import PaymentMethod from './components/variables/payment-method.vue';
import Recurrence from './components/variables/recurrence.vue';
import Coregs from '../common/components/coregs.vue';


/**
 * Services
 */
import configService from '../common/services/configs';
import multipleConfigService from './services/configs';
import TrackingService from '../common/services/tracking';

/**
 * Modules
 */
import utils from '../common/modules/utils';
import MixinQueryParameters from '../common/mixins/query-parameters';
import urlGenerator from '../common/mixins/url-generator';

import MixinOrder from './mixins/order';
import MixinUrlGenerator from '@/common/mixins/url-generator';
import MixinAlert from '@/common/mixins/alert';
import MixinStorage from '@/common/mixins/storage';
import MixinExpiration from './mixins/expiration';

/**
 * Constants, mutations
 */
import * as constants from '../common/constants';
import * as mutations from './store/mutations';

export default {
  mixins: [
    MixinOrder,
    MixinExpiration,
    SentryLogger,
    MixinAlert,
    MixinUrlGenerator,
    MixinStorage,
    MixinQueryParameters,
    urlGenerator
  ],
  components: {
    PaymentSwitchButton,
    ValidateOrderButton,
    ContactForm,
    PaymentForm,
    BillingRecap,
    PaymentMethod,
    Recurrence,
    AmountOldTotalCc,
    AmountOldTotalSepa,
    AmountOldTotalX1,
    AmountOldTotalX3Total,
    AmountOldTotalX3,
    AmountOldTotal,
    AmountTotalCc,
    AmountTotalSepa,
    AmountTotalX1,
    AmountTotalX3Total,
    AmountTotalX3,
    AmountTotal,
    AmountTotalDiffX1X3Total,
    AmountTotalX2,
    AmountOldTotalX2,
    AmountOldTotalX2Total,
    AmountTotalX2Total,
    AmountTotalDiffX1X2Total,
    ChoiceOldPrice,
    ChoicePriceCc,
    ChoicePriceSepa,
    ChoicePriceX1,
    ChoicePriceX3Total,
    ChoicePriceX3,
    ChoicePrice,
    ChoicePriceRecurrence,
    ChoiceDescription,
    Coregs,
    OrderRecap,
    OopsButton
  },
  data() {
    return {
      timeoutWatchFormData: null,
      timeoutWatchChoiceList: null
    };
  },
  computed: {
    ...mapState({
      contractedProducts: state => state.products.contractedProducts
    }),
    ...mapGetters([
      /**
       * Debug
       */
      'testLevel',
      'sentry',
      /**
       * User
       */
      'locale',
      'sfId',
      /**
       * Configs service
       */
      'localConfig',
      'journeyConfig',
      'affiliateConfig',
      'orderFormConfig',
      /**
       * Payment
       */
      'recurrence',
      'paymentId',
      'paymentAccountIdentifier',
      'paymentMethod',
      'campaignCode',
      /**
       * MarketingCloud
       */
      'mbParams',
      'marketingCloudParams',
      /**
       * Form
       */
      'conditionsApproved',
      'cgsApproved',
      'formData',
      /**
       * Choices
       */
      'choices',
      'choiceList',
      /**
       * Order
       */
      'currentOrderUid'
    ])
  },
  methods: {
    ...mapActions('products', [
      'setAlreadyContractedProducts'
    ]),
    ...mapMutations({
      setChoices: mutations.SET_CHOICES
    }),
    /**
     * Dispatch the vanguard-ready Custom event, used by integrators to excecute there own JS code
     * @return {[type]} [description]
     */
    dispatchVanguardReady() {
      const e = new CustomEvent('vanguard-ready', {});
      console.log('[vanguard] event:vanguard-ready');
      document.dispatchEvent(e);
    },
    /**
     * Initialize order-form or entrypoint page
     */
    async initOrderFormPage() {
      console.log('[vanguard] initialize entrypoint');

      // Init orders queue
      this.initOrdersQueue();

      await this.filterChoiceList();

      /**
       * Retrieve the default choice if exists in order to set the paymentMethod and the recurrence
       */
      let defaultChoice;
      if (this.choices && this.choices.length > 0) {
        defaultChoice = this.choices.find(choice => {
          return choice.isDefault;
        });

        /**
         * If any choices are setted with default flag, we take the first one
         */
        if (!defaultChoice) {
          defaultChoice = this.choices[0];
        }

        this.$store.commit(mutations.SET_PAYMENT_METHOD, defaultChoice.paymentMethod);
        this.$store.commit(mutations.SET_RECURRENCE, defaultChoice.recurrence);
      }

      /**
       * Cookies management
       * - clear all previous cookies
       */
      this.$cookies.config('1d'); // Default config : cookies expires after 1 day

      this.$cookies.remove('CURRENT_ORDER_ID');
      this.$cookies.remove('CUSTOMER_INFO');
      this.$cookies.remove('PALYANCE_PAYMENT_ID');
      this.$cookies.remove('PAYMENT_METHOD');
      this.$cookies.remove('PREVIOUS_CHOICE_TYPE');
      this.removeStoragePreviousChoice();
      this.$cookies.remove('PREVIOUS_ORDER_ID');
      // - set current order ID
      this.$cookies.set('CURRENT_ORDER_ID', this.currentOrderUid);

      /**
       * Initialize components after DOM Ready
       */
      $(document).ready(() => {
        /**
         * Add into the dataLayer the productCode of the orderForm's publication
         */
        TrackingService.pushEntryPointData({
          productCode: this.localConfig.productCode
        });

        this.dispatchVanguardReady();
      });
    },
    initConfirmationPage() {
      /**
       * Retreive data from cookies about what choices was bought
       */
      let stateFromCookies = this.$cookies.get('CHOICE_LIST_STATES');
      if (stateFromCookies) {
        try {
          stateFromCookies = JSON.parse(stateFromCookies);
        } catch (error) {
          if (error) {
            stateFromCookies = [];
          }
        }
      } else {
        stateFromCookies = [];
      }

      this.$store.commit(mutations.SET_CHOICE_LIST, stateFromCookies);
      /**
       * Clear the cookie
       */
      // this.$cookies.remove('CHOICE_LIST_STATES');

      /**
       * Retreive the paymentMethod and the recurrence
       */
      this.$store.commit(mutations.SET_PAYMENT_METHOD, this.$cookies.get('PAYMENT_METHOD') || '');
      this.$store.commit(mutations.SET_PAYMENT_ID, this.$cookies.get('PALYANCE_PAYMENT_ID') || '');
      this.$store.commit(mutations.SET_RECURRENCE, this.$cookies.get('RECURRENCE') || '');

      Promise.all([
        multipleConfigService.getOrderFormConfigFile.bind(this)(mutations)
      ]).then(async () => {
        // Init Confirmation Components
        this.setChoices(this.orderFormConfig ? this.orderFormConfig.choices : []);
      });
    },
    async filterChoiceList() {
      if (!this.sfId) {
        this.setChoices(this.localConfig.choices);
        return;
      }

      await this.setAlreadyContractedProducts({
        sfId: this.sfId,
        affiliateId: this.affiliateConfig.affiliateId,
        products: new Set(this.localConfig.choices.map(choice => choice.productId))
      });

      const availableChoices = this.localConfig.choices.filter(choice => {
        return !this.contractedProducts.filter(product => {
          return choice.productId === product.productId && product.already;
        }).length;
      });

      // If all choices already contracted, redirect error
      if (availableChoices.length === 0) {
        console.error('No more products available');
        this.redirectToErrorPage();
        return;
      }

      this.setChoices(availableChoices);
    },
    isSfIdValid(sfId) {
      const sfIdRegexReject = /^.{40}$/; // Exactly 40 characters

      return sfId && sfIdRegexReject.test(sfId);
    },
    getCurrentEmailAddress() {
      return this.formData.billing && this.formData.billing.billingEmail ?
        this.formData.billing.billingEmail :
        '';
    },
    /**
     * Redirect to affiliate error page
     * e.g. https://{subdomain}/error.html
     */
    redirectToErrorPage() {
      window.location = this.appendQueryParamsBeforeRedirection(`${window.location.origin}/static/${this.locale}/error.html`);
    }
  },
  created() {
    console.log('[vanguard-multiple] @' + version);
    this.sentryInit('vanguard-multiple@' + version);

    /**
     * Global try/catch on created()
     */
    try {
      /**
       * Generate and store order UID
       */
      this.$store.commit(mutations.SET_CURRENT_ORDER_UID, utils.generateUID());

      /**
       * Retrieve query params and save some data into the store
       */
      this.getQueryParams(mutations);

      /**
       * If testLevel is setted, display test banner
       */
      this.showTestAlert();

      const waitingPageErrorStatus = localStorage.getItem(constants.WAITING_PAGE_ERROR_STATUS_LOCALSTORAGE_KEY);
      const waitingPageErrorMessage = localStorage.getItem(constants.WAITING_PAGE_ERROR_MESSAGE_LOCALSTORAGE_KEY);
      if (waitingPageErrorStatus && waitingPageErrorMessage) {
        this.showPaymentErrorAlert(waitingPageErrorMessage);
        localStorage.removeItem(constants.WAITING_PAGE_ERROR_STATUS_LOCALSTORAGE_KEY);
        localStorage.removeItem(constants.WAITING_PAGE_ERROR_MESSAGE_LOCALSTORAGE_KEY);
      }

      /**
       * Retreive configs
       */
      Promise.all([
        configService.getAffiliateConfigFile.bind(this)(mutations),
        configService.getJourneyConfigFile.bind(this)(mutations),
        configService.getLocalConfigFile.bind(this)(mutations)
      ]).then(() => {
        // Check campaign redirection
        if (this.campaignCode && this.journeyConfig.campaignsRedirects) {
          const campaignsRedirect = this.journeyConfig.campaignsRedirects.filter(campaign => campaign.code === this.campaignCode);
          if (campaignsRedirect.length > 0 && campaignsRedirect[0].redirectUrl) {
            const queryParamsRedirectUrl = campaignsRedirect[0].redirectUrl.includes('?') ?
              document.location.search.replace('?', '&') : document.location.search;
            document.querySelector('body').style.display = 'none';
            window.location.href = campaignsRedirect[0].redirectUrl + queryParamsRedirectUrl;
            return;
          }
        }

        /**
         * Redirect to error page if the sfId exists and isn't valid
         */
        if (this.sfId && !this.isSfIdValid(this.sfId)) {
          console.error('sfId is not valid');
          this.redirectToErrorPage();
        }

        /**
         * Setup the locale
         * Update locale vue-i18n on fly (should work for the entire app)
         */
        let {locale} = VanguardConfig;
        if (this.journeyConfig && this.journeyConfig.lang) {
          locale = this.journeyConfig.lang;
        }

        this.$store.commit(mutations.SET_LOCALE, locale);
        this.$i18n.locale = this.locale;

        /**
         * Temporary solution (in order to wait a cleaner feature to permit to the users to set a default country ID)
         * If the locale is setted to 'es', let's update the default country with Spain
         */
        if (this.locale === 'es') {
          this.$store.commit(mutations.SET_BILLING_COUNTRY, 'ESP');
          this.$store.commit(mutations.SET_SHIPPING_COUNTRY, 'ESP');
        }

        if (this.locale === 'it') {
          this.$store.commit(mutations.SET_BILLING_COUNTRY, 'ITA');
          this.$store.commit(mutations.SET_SHIPPING_COUNTRY, 'ITA');
        }

        if (this.locale === 'de') {
          this.$store.commit(mutations.SET_BILLING_COUNTRY, 'DEU');
          this.$store.commit(mutations.SET_SHIPPING_COUNTRY, 'DEU');
        }

        if (!this.affiliateConfig.affiliateId) {
          console.error('No affiliateId provided', this.affiliateConfig);
          this.redirectToErrorPage();
          return;
        }

        if (this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_CHOICE_LIST_1CLICK && !this.isSfIdValid(this.sfId)) {
          console.error('orderForm 1click', 'sfId not valid');
          this.redirectToErrorPage();
          return;
        }

        // Check whether order form is expired
        if (this.isOrderFormExpired()) {
          return;
        }

        /**
         * Tracking service : send marketing cloud values
         */
        const pathElements = window.location.pathname.split('/');
        if (this.testLevel !== constants.TEST_LEVEL_VANGUARD && this.testLevel !== constants.TEST_LEVEL_ORION) {
          const trackingService = new TrackingService();
          if (this.affiliateConfig.marketingCloudId) {
            trackingService.setMarketingCloudId(this.affiliateConfig.marketingCloudId);
          }

          if (this.journeyConfig.publicationCode) {
            trackingService.addTrackPageViewItem('item', this.journeyConfig.publicationCode);
          }

          let pageType = '';
          if (this.isInitialOrderForm) {
            pageType = 'order';
          } else if (pathElements[pathElements.length - 1] === 'cancel.html') {
            pageType = 'cancel';
          } else {
            pageType = 'confirm';

            const previousChoice = this.getStoragePreviousChoice();
            if (previousChoice) {
              trackingService.setTrackConversionCart({item: previousChoice.name, quantity: 1, price: previousChoice.price});

              trackingService.addTrackConversionOtherItem('order_number', this.$cookies.get('PREVIOUS_ORDER_ID'));
              trackingService.addTrackConversionOtherItem('shipping', previousChoice.shippingPrice ? parseFloat(previousChoice.shippingPrice) : 0);
            }
          }

          const queryParams = utils.getQueryParams();
          if (queryParams.sk) {
            trackingService.setUserInfoItem('email', queryParams.sk);
          }

          trackingService.addTrackPageViewItem('category', pageType);
        }

        /**
         * Initialize the right page
         */
        if (window.location.pathname.includes('confirmation')) {
          this.initConfirmationPage();
        } else {
          this.initOrderFormPage();
        }
      });
    } catch (error) {
      this.sendSentryLog(
        Severity.Fatal,
        'Error while initializing app, outside from config files Promise',
        {error});
    }
  },
  watch: {
    choices(value) {
      if (value) {
        /**
         * Show the choices that are allowed to be purchased
         */
        value.forEach(choice => {
          document.querySelectorAll(`.multiple-choices-list[data-choice-stack-letter="${choice.stackLetter}"]`).forEach(el => {
            el.style.display = 'block';
          });
        });
      }
    },
    /**
     * Send order draft if any data from the formData changed
     */
    formData: {
      deep: true,
      handler() {
        if (this.formData.billing.billingEmail && this.timeoutWatchFormData === null) {
          /**
           * Just deplay the update after 500ms of "non modifications" on the formData
           * we dont want to send an orderDraft after each characher has been modified
           */
          this.timeoutWatchFormData = setTimeout(() => {
            this.timeoutWatchFormData = null;
            this.sendOrderData();
          }, 500);
        }
      }
    },
    /**
     * Send the order draft after that EACH changes on the paymentMethod
     */
    paymentMethod() {
      if (this.formData.billing.billingEmail) {
        this.sendOrderData();
      }
    },
    recurrence() {
      if (this.formData.billing.billingEmail) {
        this.sendOrderData();
      }
    },
    /**
     * Send the order draft after that EACH changes on the choiceList (selected choices by the user)
     */
    choiceList() {
      if (this.formData.billing.billingEmail && this.timeoutWatchChoiceList === null) {
        /**
         * Same principal for the choiceList
         */
        this.timeoutWatchChoiceList = setTimeout(() => {
          this.timeoutWatchChoiceList = null;
          this.sendOrderData();
        }, 500);
      }
    },
    conditionsApproved(value) {
      if (value && this.formData.billing.billingEmail) {
        this.sendOrderData();
      }
    },
    cgsApproved(value) {
      if (value && this.formData.billing.billingEmail) {
        this.sendOrderData();
      }
    },
    formIsValid(value) {
      if (!value) {
        return;
      }

      console.log('[vanguard] formValid, sendOrderData');
      this.sendOrderData();
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/app.js